// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__mzsdp","content":"LayoutSettings_content__3AGwQ"};